module.exports = __webpack_public_path__ + "media/images/products/cards/tesouro_direto-d1a525c93d97aa1526240f1b48967921.png";